import { render, staticRenderFns } from "./MiniCard.yaml?vue&type=template&id=6644cb14&component"
import script from "./MiniCard.yaml?vue&type=script&lang=ts&component"
export * from "./MiniCard.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports